import { ReactNode } from 'react';

export const HomePageSection = ({
  children,
  title,
  footer,
  rightHeaderContent
}: {
  children: ReactNode;
  title: ReactNode;
  rightHeaderContent?: ReactNode;
  footer?: ReactNode;
}) => {
  return (
    <section className="rio-home-page-section">
      <header className="slds-p-around--x-small">
        <div
          className="slds-text-align--center slds-text-heading--small"
          title={typeof title === 'string' ? title : undefined}
        >
          {title}
        </div>
        <div>{rightHeaderContent}</div>
      </header>
      {children && <div className="rio-home-page-section__content">{children}</div>}
      {footer && (
        <footer
          style={{ background: '#121011' }}
          className="slds-p-around--xx-small slds-text-align--center slds-text-body--small"
        >
          {footer}
        </footer>
      )}
    </section>
  );
};
